import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export function FormField({ label, required, children, sx }) {
  return (
    <SoftBox sx={sx}>
      {label ? (
        <SoftTypography variant="caption" fontWeight="bold" color="text" mb={0.5} display="block">
          {label}
          {required ? " *" : ""}
        </SoftTypography>
      ) : null}
      {children}
    </SoftBox>
  );
}

FormField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export function FormSelect({
  value,
  onChange,
  required,
  placeholder,
  children,
  compact,
  disabled,
  name,
  className,
}) {
  const wrapClass = ["select-wrap", compact ? "select-wrap-compact" : "", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapClass}>
      <select
        className={compact ? "select Category select-compact" : "select Category"}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {children}
      </select>
    </div>
  );
}

FormSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  children: PropTypes.node,
  compact: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  className: PropTypes.string,
};

export const tableHeadCellSx = {
  fontWeight: 700,
  fontSize: "0.68rem",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "text.secondary",
  bgcolor: "grey.50",
  borderBottom: 2,
  borderColor: "divider",
  whiteSpace: "nowrap",
  py: 1.25,
  px: 1.5,
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const tableBodyCellSx = {
  py: 1.25,
  px: 1.5,
  verticalAlign: "middle",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

/** Full-width scrollable table wrapper; keeps header/body columns aligned when scrollbar appears */
export const crmTableContainerSx = {
  width: "100%",
  border: 1,
  borderColor: "divider",
  borderRadius: 2,
  maxHeight: 560,
  overflow: "auto",
  scrollbarGutter: "stable",
};

/** Fixed layout so colgroup widths match header and body cells */
export const crmTableSx = (minWidth) => ({
  tableLayout: "fixed",
  width: "100%",
  minWidth: minWidth || "100%",
});
